var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.final_files.length > 0
    ? _c(
        "div",
        { staticClass: "counterparty" },
        [
          _c("legend", [_vm._v("\n        Поточна версія договору\n    ")]),
          _vm._v(" "),
          _c("b-table", {
            staticClass: "table-responsive-xl resolution_table",
            attrs: {
              striped: "",
              "head-variant": "dark",
              "thead-class": _vm.head_class,
              striped: "",
              items: _vm.final_files,
              fields: _vm.fields,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "head(link)",
                  fn: function (data) {
                    return [
                      _c("span", { staticClass: "text-info text-center" }, [
                        _c("i", {
                          staticClass: "fa fa-floppy-o",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]),
                    ]
                  },
                },
                {
                  key: "cell(link)",
                  fn: function (data) {
                    return [
                      _c(
                        "span",
                        {
                          staticClass:
                            "get_file cursor-pointer text-center fs-xl",
                          on: {
                            click: function ($event) {
                              return _vm.get_file(data.item)
                            },
                          },
                        },
                        [_c("i", { staticClass: "fal fa-save save_me" })]
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              3914855108
            ),
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }